import { render, staticRenderFns } from "./planActionBfp.vue?vue&type=template&id=26b880c6&scoped=true"
import script from "./planActionBfp.vue?vue&type=script&lang=js"
export * from "./planActionBfp.vue?vue&type=script&lang=js"
import style0 from "./planActionBfp.vue?vue&type=style&index=0&id=26b880c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b880c6",
  null
  
)

export default component.exports